<template>
  <!-- <form class="form-horizontal" method="post" id="id_post_m_form" v-on:submit.prevent="submit(0)" v-if="is_show"> -->
  <form class="form-horizontal" method="post" id="id_post_m_form" v-if="is_show">
    <template v-if="!isUploadFile">

      <template v-for="node in nodes">
        <div class="node lp-question" :key="node.id" v-show="(node.alias!='ApplyFrom') && (node.alias!='FileIndexList') && (node.alias!='ApplyPassword')&&(node.id!='157203b3f4c49ef04a2d5ee21db8403b462e6ea3')&&(node.id!='5245bfbba8304e2d210906f9698309496ff3b880')">
          <input type="hidden" name="node" :value="node.id">
          <div class="lp-question--title">
            <strong>{{ node.title }}</strong>
          </div>

          <div class="cells lp-question-radio" v-if="node.action_type == 1 || node.action_type == 4">
            <label class="cells-check__label" v-for="child in node.items" :key="child.id" @dblclick.prevent="cancel_select(node, child, $event)" :class="{checked: child.checked}">
              <div class="cells-check__icon" @click="radio_checked(node, child, $event)"></div>
              <div class="cells-check__bd">
                <div class="cells-check__title" :id="node.id" @click="radio_checked(node, child, $event)">
                  {{child.title}}
                </div>
                <input-widget class="lp-r-input" v-on:add_item="add_item" :node="child" :parentNode="node" v-on:update="input_complete" v-if="child.checked" v-on:on_keyup="on_keyup" @click="onClick" />
              </div>
            </label>
          </div>
          <div class="cells lp-question-checkbox" v-else-if="node.action_type == 2">
            <label class="cells-check__label" v-for="child in node.items" :class="{checked: child.checked}" :key="'key-checkbox-'+child.id">
              <input type="checkbox" class="weui-check" :value="child.id" @change="checkbox_checked(node, child, $event)" v-model="child.checked">
              <div class="cells-check__icon" @click="checkbox_checked(node, child, $event)"></div>
              <div class="cells-check__bd">
                <div class="cells-check__title" :id="node.id" @click="checkbox_checked(node, child, $event)">
                  {{child.title}}
                </div>
                <input-widget v-on:add_item="add_item" :node="child" :parentNode="node" v-on:update="input_complete" v-if="child.checked" v-on:on_keyup="on_keyup" @click="onClick" />
                <!-- <p :class="{checked: child.checked}">{{ child.title }}</p> -->
              </div>
            </label>
          </div>
          <div class="cells-form" v-else-if="node.action_type == 5">

            <div v-for="(child,ii) in node.items" :key="'key-multiple-inputs'+ii" class="lp-question-form">
              <div class="cells-title">{{ child.title }}</div>
              <div class="cells-bd">
                <input-widget v-on:add_item="add_item" :node="child" :parentNode="node" v-on:update="input_complete" v-on:on_keyup="on_keyup" />
              </div>
            </div>

          </div>

          <div class="cells lp-question-text" v-else-if="node.action_type == 3 && node.input_type !=27">
            <div class="cells-bd">
              <!-- <input class="weui-input" type="text" placeholder="请输入文本"> -->
              <input-widget v-on:add_item="add_item" :node="node" :parentNode="node" v-on:update="input_complete" @on_keyup="on_keyup" />
              <div class="cells-bd-counter" v-if="node.input_type ==13">
                <span>{{node.default.length}}</span>/200
              </div>
            </div>
          </div>
          <!-- 公证使用地 -->
          <template v-else-if="node.action_type == 3 && node.input_type==27">
            <input-widget v-on:add_item="add_item" :node="node" :parentNode="node" v-on:update="input_complete" @on_keyup="on_keyup" />
          </template>

        </div>
      </template>
    </template>
    <div class="node lp-question upload-panel-node" v-if="isUploadFile">
      <div class="lp-question--title">
        <strong>使用手机扫码上传相关文件</strong>
        <div class="qrcode-panel">
          <div id="qrcode">
            <img :src="qrurl" width="200" />
          </div>
        </div>
      </div>
    </div>
    <div class="page-container" v-if="nodes.length">
      <div class="lp-question--btn-submit">
        <button type="button" v-if="isInputFile&&!isUploadFile" v-on:click.stop.prevent="setFileRest" style="background-color:#108ee9">返回重新上传</button>
        <button type="button" v-if="isUploadFile" v-on:click.stop.prevent="initData" style="background-color:#4db56d">上传完成</button>
        <button type="button" v-if="is_show_submit_btn && !isInputFile || isInputFile&&!isUploadFile" v-on:click.stop.prevent="submit(1, $event)">提交保存</button>
      </div>
    </div>

    <div v-show="hide" class="fayuan-dialog-box">
      <div class="fayuan-mask"></div>
      <div class="fayuan-dialog">
        <div class="fayuan-dialog__hd">
          <strong class="fayuan-dialog__title">提示</strong>
        </div>
        <div class="fayuan-dialog__bd">
          <ol id="ol-complete" class="complete-ol" v-html="hidemsg" style="list-style-type: decimal;text-align:left"></ol>
        </div>
        <div class="fayuan-dialog__ft">
          <a href="javascript:;" @click.prevent="hide=false" class="fayuan-dialog__btn fayuan-dialog__btn_primary">确定</a>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import inputWidget from './m_input_widget.vue'
import QRCode from 'qrcode'

import {
  getPpackageId,
  getQueryString,
  getCaseId,
  getQuery
} from '../../datas/js/common.js'

function AscSort (a, b) {
  // 正序排列
  return a.lft - b.lft
}

export default {
  name: 'data_collect_f',
  data: function () {
    return {
      nodes: [],
      nodeValues: {},
      selected: {},
      caseId: '',
      packageId: '',
      is_on_submit: 0,
      is_show_submit_btn: 0,
      lastId: '',
      is_update_selected: 0,
      currentNode: ['', ''], // node, 操作类型:'', cancel, force, parent_id
      js_c: '', // 自定义js组件
      is_show: 0, // 是否显示输入
      isSubmitnow: 0,
      no: '',
      hidemsg: '',
      hide: false,
      isUploadFile: false,
      qrurl: ''
    }
  },
  components: {
    'input-widget': inputWidget
  },
  computed: {
    machineuuid () {
      return this.$store.state.device.point.no || ''
    },
    isInputFile () {
      return this.nodes.every(v => v.input_type == 25)
    }

  },
  watch: {
    currentNode: function (newValue, oldValue) {
      var self = this
      var node = newValue[0]
      // var old_node = oldValue[0]

      /*
      如果是选项
      第一次选: node 有值， old_node 没有值， 判断node有没有u,有u就更新，没有u就不更新
      第二次选: node 等于cancel, 判断node有没有u
      第三次选: node等于cancel, old_node也等于cancel, cancel类型需要为list, 判断node有没有u
      第四次选: node有值，old_node等于cancel, 就判断node有没有u
      第五次选: node有值，old_node也有值，但是不同的题，就判断node有没有u
      第六次选: node有值，old_node也有值，是同一个题，并且是单选题，就判断node有没有u，也要判断 old_node有没有u
      第7次选: node有值，old_node也有值，是同一个题，并且是多选题，就判断node有没有u
      第八次选: node有值，old_node也有值，有强制更新，就必须更新
      */

      var isUpdate = 0
      if (newValue[1] === 'force') {
        isUpdate = 1
      } else if (newValue[0].u) {
        isUpdate = 1
      }

      // self.getNextData(node.id);
      if (isUpdate) {
        self.getNextData(node.id)
      }
    },
    nodes (val) {
      const ishasfileval = val.some(v => v.default.length)
      const flag = this.isInputFile && !ishasfileval
      this.isUploadFile = flag
      if (this.isUploadFile) {
        this.setQrcode()
      }
    },

  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      var self = this
      this.no = getQueryString('no') || ''
      var query = getQuery()
      var packageId = getPpackageId()
      var caseId = getCaseId()
      var url = 'https://yn.12348.laway.cn/node/next/' + packageId + '/'
      var userId = self.$store.state.user.wechatUinfo.userid
      self.caseId = caseId
      self.packageId = packageId
      var data = { case_id: self.caseId, package_id: self.packageId, user_id: userId }
      self.lastId = self.packageId
      $.post(url + query, data, function (results) { //eslint-disable-line
        self.nodes = results
        self.nodes.sort(AscSort)
        setTimeout(function () {
          results.forEach(function (item) {
            self.selected['q_' + item.id] = item.id
            if (item.items && item.items.length) {
              item.items.forEach(function (child) {
                if (child.checked) {
                  self.selected['q_' + child.id] = child.id
                }
              })
            } else if (
              item.action_type === 3 &&
              item.input_type === 29 &&
              item.input_args
            ) {
              self.js_c = item.input_args
            }
          })
          self.is_show_submit_btn = 1
          self.is_show = 1
          self.$nextTick(self.regCheck)
        }, 0)


      })
    },
    setFileRest () {
      this.isUploadFile = true
    },
    async setQrcode () {
      const link = `https://yn.12348.laway.cn/pufa/yunnan/mobile/#${this.$route.path}?terminaluser=${this.$store.state.user.wechatUinfo.userid}&step=${this.$route.query.step}&only_upload_file=1`
      this.qrurl = await QRCode.toDataURL(link)
    },
    onClick: function () {
      this.is_click_done = 1
    },
    // POSITIVE_INTEGER:正整数  | IDNUM:身份证  |  VCODE:整数
    regCheck () {
      weui.form.checkIfBlur('#id_post_m_form', { //eslint-disable-line
        regexp: {
          IDNUM: /(?:^\d{15}$)|(?:^\d{18}$)|^\d{17}[\dXx]$/, //eslint-disable-line
          VCODE: /^.{4}$/, //eslint-disable-line
          INTEGER: /^[-\+]?\d+$/, //eslint-disable-line
          POSITIVE_INTEGER: /^[0-9]+$/ //eslint-disable-line
        }
      })
    },
    cancel_select: function (parentNode, current, event) {
      var self = this
      // 如果是取消
      // 隐藏子集子节点数据
      if (self.selected['q_' + current.id]) {
        delete self.selected['q_' + current.id]
      }
      self.currentNode = [current, 'cancel']

      if (self.selected['q_' + parentNode.id]) {
        delete self.selected['q_' + parentNode.id]
      }
      current.checked = ''
      self.getCurrentSelected(parentNode, current)
      self.is_update_selected = 1
    },
    get_input_val: function (node) {
      if (
        node.input_type === 21 &&
        node.input_widget &&
        node.input_widget.action_type === 2
      ) {
        return node.default
      } else if (node.input_type === 23 && node.input_items) {
        var results = []
        node.items.forEach(function (item) {
          var row = []
          var i = 0
          item.forEach(function (field) {
            row.push({ id: node.input_items[i].id, val: field.default })
            i += 1
          })
          results.push(row)
        })
        return results
      } else {
        return [node.default]
      }
    },
    on_keyup: function (e, parentNode, node) {
      var self = this
      if (self.nodeValues['q_' + node.id]) {
        if (self.nodeValues['q_' + node.id] !== node.default) {
          self.nodeValues['q_' + node.id] = node.default
        }
      } else {
        self.nodeValues['q_' + node.id] = node.default
      }
      self.selected['q_' + parentNode.id] = node.id
    },
    input_complete (e, parentNode, node) {
      console.log('input_complete')
      var self = this
      var isUpdate = 1
      self.currentNode = [node, '']
      self.selected['q_' + parentNode.id] = node.id
      if (isUpdate) {
        this.update_panel(parentNode, node)
      }
    },
    add_item: function (node, event) {
      var row = []
      var i = {}
      var l = node.items.length
      node.items[0].forEach(function (item) {
        i = {}
        $.extend(i, item) // eslint-disable-line
        i.id = i.id + '_' + l
        i.default = ''
        row.push(i)
      })
      node.items.push(row)
    },
    getCurrentSelected: function (parentNode, current) {
      var self = this
      var currentSelected = {}
      var nodesKey = []
      if (current) {
        self.current_key = current.id
      }
      var nodes = self.nodes.map(function (nodeItem) {
        if (nodeItem.action_type === 4 || nodeItem.action_type === 1) {
          var checkedItem = false
          nodeItem.items.map(function (childNode) {
            if (parentNode && nodeItem.id === parentNode.id) {
              if (current && current.checked && childNode.id === current.checked) {
                checkedItem = childNode
                childNode.checked = current.id
              } else {
                childNode.checked = ''
              }
              return childNode
            } else if (childNode.checked) {
              checkedItem = childNode
              return childNode
            }
          })
          currentSelected[nodeItem.id] = { t: nodeItem.title }
          if (checkedItem) {
            if (nodesKey.indexOf(nodeItem.id) === -1) {
              nodesKey.push(nodeItem.id)
            }

            // if (checkedItem.default) {
            if (checkedItem.input_type) {
              currentSelected[checkedItem.id] = {
                t: checkedItem.title,
                val: self.get_input_val(checkedItem)
              }
            } else {
              currentSelected[checkedItem.id] = { t: checkedItem.title }
            }
          }
        } else if (nodeItem.action_type === 2) {
          var checkedList = []
          nodeItem.items.forEach(function (childNode) {
            if (childNode.checked) {
              checkedList.push(childNode.id)
              if (
                childNode.default ||
                (current &&
                  childNode.id === current.id &&
                  childNode.default === '')
              ) {
                currentSelected[childNode.id] = {
                  t: childNode.title,
                  val: self.get_input_val(childNode)
                }
              } else {
                currentSelected[childNode.id] = { t: childNode.title }
              }
            }
          })

          currentSelected[nodeItem.id] = { t: nodeItem.title }
          if (checkedList.length) {
            if (nodesKey.indexOf(nodeItem.id) === -1) {
              nodesKey.push(nodeItem.id)
            }
            currentSelected[nodeItem.id] = { t: nodeItem.title }
          }
        } else if (nodeItem.action_type === 3) {
          if (
            nodeItem.action_type === 3 &&
            nodeItem.input_type === 29 &&
            nodeItem.input_args
          ) {
            self.js_c = nodeItem.input_args
            // console.log('nodeItem.input_args:');
            // console.log(nodeItem.input_args);
            // console.log(nodeItem.default);
          }

          currentSelected[nodeItem.id] = {
            t: nodeItem.title,
            val: self.get_input_val(nodeItem)
          }
          if (nodesKey.indexOf(nodeItem.id) === -1) {
            nodesKey.push(nodeItem.id)
          }
        } else if (nodeItem.action_type === 5) {
          nodeItem.items.forEach(function (childNode) {
            currentSelected[nodeItem.id] = { t: nodeItem.title }

            if (childNode.input_type) {
              currentSelected[childNode.id] = {
                t: childNode.title,
                val: self.get_input_val(childNode)
              }
            } else {
              currentSelected[childNode.id] = { t: childNode.title }
            }
            if (nodesKey.indexOf(nodeItem.id) === -1) {
              nodesKey.push(nodeItem.id)
            }
          })
        }
        return nodeItem
      })
      self.nodes = nodes
      self.currentSelected = currentSelected
      self.nodesKey = nodesKey
    },
    radio_checked: function (node, current, event) {
      // 如果选择了radio
      // var children = []
      var self = this
      self.onClick()
      var isUpdate = true
      // 判断是否选择过了,
      var action = ''

      if (!self.selected['q_' + current.id]) {
        // 如果没有选择过
        node.items.forEach(function (item) {
          if (item.id === current.id) {
            self.selected['q_' + node.id] = node.id
            self.selected['q_' + current.id] = current.id
          } else if (self.selected['q_' + item.id]) {
            if (item.u) {
              action = 'force'
            }
            delete self.selected['q_' + item.id]
          }
        })
        self.currentNode = [current, action]
      } else {
        // 如果选择过了
        isUpdate = false
      }
      // 需要更新
      if (isUpdate) {
        this.$set(current, 'checked', current.id)
        self.getCurrentSelected(node, current)
      }
    },
    checkbox_checked: function (node, child, event) {
      // 如果选择了radio
      // var children = []
      var self = this
      self.onClick()
      var isUpdate = true
      // 判断是选中还是取消
      if (child.checked) {
        // 如果是选中
        isUpdate = true
        self.selected['q_' + node.id] = child.id
        self.selected['q_' + child.id] = child.id
        self.currentNode = [child, '']
      } else {
        // 如果是取消
        // 隐藏子集子节点数据
        isUpdate = true
        // self.selected[event.target.name] = event.target.value;
        // self.selected[child.id] = child.id;
        if (self.selected['q_' + child.id]) {
          delete self.selected['q_' + child.id]
        }
        self.currentNode = [child, 'cancel']
      }

      // 需要更新
      if (isUpdate) {
        self.getCurrentSelected(node, child)
      }
    },
    update_panel: function (parentNode, node) {
      var self = this
      self.getCurrentSelected(parentNode, node)
    },
    getNextData: function (currentid) {
      var self = this
      // var userId = '5bd91ce0e92c16093a02aad2'
      var userId = self.$store.state.user.wechatUinfo.userid
      var d = { package_id: self.packageId, case_id: self.caseId, 'user_id': userId }
      d['c'] = encodeURI(JSON.stringify(self.currentSelected))
      d['s'] = self.currentKey
      self.lastId = currentid
      self.is_show_submit_btn = 0
      $.post('https://yn.12348.laway.cn/node/next/' + currentid, d, function (results) {  // eslint-disable-line
        if (self.is_update_selected) {
          self.selected = {}
          self.is_update_selected = 0
          results.forEach(function (item) {
            if (
              item.action_type === 3 &&
              item.input_type === 29 &&
              item.input_args
            ) {
              self.js_c = item.input_args
            }
            self.selected['q_' + item.id] = item.id
            if (item.items && item.items.length) {
              item.items.forEach(function (child) {
                if (child.checked) {
                  self.selected['q_' + child.id] = child.id
                }
              })
            }
          })
        } else {
          results.map(function (item) {
            if (
              item.action_type === 3 &&
              item.input_type === 29 &&
              item.input_args
            ) {
              self.js_c = item.input_args
            }

            if (self.nodeValues['q_' + item.id]) {
              item.default = self.nodeValues['q_' + item.id]
            }
            if (self.selected['q_' + item.id] && item.items) {
              item = item.items.map(function (child) {
                if (child.id === self.selected['q_' + child.id]) {
                  child.checked = child.id
                } else {
                  child.checked = ''
                }
                if (self.nodeValues['q_' + child.id]) {
                  child.default = self.nodeValues['q_' + child.id]
                }
                return child
              })
            }
            return item
          })
        }

        self.nodes = results

        // 排序
        self.nodes.sort(AscSort)

        self.is_show_submit_btn = 1
      })
    },
    submit (state, event) {
      if (!state) {
        return false
      }
      var self = this
      self.iSsubmitnow = 1
      self.getCurrentSelected()

      var d = { package_id: self.packageId, case_id: self.caseId, machine_uuid: this.machineuuid }
      d['n'] = JSON.stringify(self.nodesKey)
      d['c'] = encodeURI(JSON.stringify(self.currentSelected))
      if (self.is_on_submit) {
        return 0
      }
      self.is_on_submit = 1

      setTimeout(function () {
        self.is_on_submit = 0
      }, 3000)

      let postUrl = window.location.href.split('/case').length === 2 ? '/case/' + window.location.href.split('/case')[1] : ''
      postUrl = this.$route.fullPath
      // let userId = '5bd91ce0e92c16093a02aad2'
      var userId = this.$store.state.user.wechatUinfo.userid
      postUrl = postUrl.indexOf('?') > 0 ? `${postUrl}&user_id=${userId}` : `${postUrl}?user_id=${userId}`
      postUrl = postUrl.replace('soldier', 'peasants')
      postUrl = postUrl.replace('military', 'peasants')
      $.ajax({// eslint-disable-line
        type: 'post',
        dataType: 'json',
        url: 'https://yn.12348.laway.cn' + postUrl,
        data: d,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        success: function (results) {
          if (results.state === 'done') {
            self.$router.push(results.url)
          } else if (results.is_complete === 0) {
            self.hidemsg = results.html
            self.hide = true
          } else {
            // alert('eee')
            alert(results.error)
          }
          self.is_on_submit = 0
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.fayuan-dialog-box
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 410
  .fayuan-mask
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.4)
  .fayuan-dialog
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    width 6rem
    min-height 2rem
    border-radius 0.08rem
    background #fff
    .fayuan-dialog__hd
      margin 0.2rem 0 0 0
      padding 0.15rem 0 0 0
      text-align center
      font-size 0.3rem
    .fayuan-dialog__bd
      font-size 0.26rem
      padding 0.25rem
      color #666
      border-bottom 1px solid #e6e6e6
      ol
        margin-left 0.3rem
    .fayuan-dialog__ft
      a
        display block
        text-align center
        color #214dbf
        line-height 0.8rem
        font-size 0.3rem
html, body
  font-size 16px
.weui-btn_primary
  background-color #2d7ffc !important
  &:active
    background-color #2063d6 !important
.weui-cells_radio .weui-check:checked+.weui-icon-checked:before, .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before
  color #2196f3
select
  &:invalid
    color #999
html, body
  color #333
  background #f8f8f8
.weui-cells_radio
  .tip
    font-size 14px
    color #999
.d-placeholder
  color #999
.lp-input-select
  padding 0
  height auto
  line-height inherit
  position relative
.lp-input-star
  color #ccc
  display flex
  align-items center
  .star
    display inline-block
    height 20px
    width 20px
    background url('data:image/png;base64,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') no-repeat
    background-size 100%
    &.on
      background url('data:image/png;base64,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') no-repeat
      background-size 100%
  .tip
    padding-left 10px
    font-size 14px
.lp-r-input
  padding-right 20%
  .weui-input
    padding 5px
    font-size 14px
    border 1px solid #ddd
    border-radius 5px
.lp-question--btn-submit
  padding 35px 0 60px
  display flex
  justify-content center
  button
    display block
    margin 0.6rem 0.1rem 0
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    border 0
    color #fff
    background-color #fc9d0b
    border-radius 0.1rem
    font-size 0.28rem
.page-container
  padding 0 15px
.lp-question
  margin-top 30px
  .lp-question--title
    font-size 16px
    color #333
    vertical-align middle
    margin 0
    strong
      vertical-align middle
    .lp-question--title-icon
      vertical-align middle
      display inline-block
      width 16px
      height 16px
      img
        width 100%
        display block
  .weui-cell
    font-size 16px
    color #666
    .weui-cell__bd .checked
      color #2196f3
.upload-panel-node
  text-align center
  .qrcode-panel
    margin-top 0.2rem
</style>
